<div class="jumbotron col-md-12 jumbotron-fluid p-3">
  <h3 translate="HANDELSELOGG_HEADER"></h3>
  <div class="row">
    <div class="controls has-feedback col-12 col-md-6 col-lg-6">
      <input type="text" ignore-readonly class="form-control"
        placeholder="{{'HANDELSELOGG_FILTER_TEXT' | translate}}" id="loggFilter" name="loggFilter"
        [(ngModel)]="loggFilter" ng-change="isopen = loggFilter && loggFilter.length > 0">
      </div>
    </div>
    <hr />
    @for (logg of logData | raskFilter: loggFilter; track logg) {
      <div class="row">
        <div ngbAccordion #acc="ngbAccordion" class="col-12">
          <div ngbAccordionItem [collapsed]="true">
            <div ngbAccordionHeader>
              <button ngbAccordionButton>{{logg.iBy + ' - ' + (logg.iDate | date:'short')}}</button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template>
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th translate="HANDELSELOGG_COLUMN_TABEL"></th>
                        <th translate="HANDELSELOGG_COLUMN_FIELD"></th>
                        <th translate="HANDELSELOGG_COLUMN_OLD_VALUE"></th>
                        <th translate="HANDELSELOGG_COLUMN_NEW_VALUE"></th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (detalj of logg.handelseloggDetaljer; track detalj) {
                        <tr>
                          <td><span>{{ detalj.tabell | raskHighlight:loggFilter }}</span></td>
                          <td><span>{{ detalj.kolumn | raskHighlight:loggFilter }}</span></td>
                          <td><span>{{ detalj.fore | raskHighlight:loggFilter }}</span></td>
                          <td><span>{{ detalj.efter | raskHighlight:loggFilter }}</span></td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
